import React from "react";
import { Row, Col } from "react-bootstrap";
import { Button } from "reactstrap";

const ReimbursementButton = (props) => {
 
  return (
    <Row className="reimbursement-btn mt-4 row-cols-2">
      <Col lg={6}>
        <Button
          className={
            props.monthlyReimburseBtn ? "changeBg" : "monthly-reimburse"
          }
          onClick={props.monthlyReimburse}
        >
          Monthly Reimbursement
        </Button>
      </Col>
      <Col lg={6}>
        <Button
          className={
            props.generalReimburseBtn ? "changeBg" : "general-reimburse"
          }
          onClick={
            props.empDepartment === "5"
              ? props.getAllEmpGeneralReimbursementList
              : props.generalReimburse
          }
        >
          General Reimbursement
        </Button>
      </Col>
    </Row>
  );
};

export default ReimbursementButton;
